module.exports = __webpack_public_path__ + "static/img/na.f63aa50a.png";